// @ts-strict-ignore
import { LMFormatterService } from './lm-formatter.service';
import { LMFormatUtilService } from '@services/utils/lm-format-util.service';

export const lmFieldFormatter  = (
  lmFormatterService: LMFormatterService,
  lmFormatUtilService: LMFormatUtilService,
  row: number,
  cell: number,
  value: any,
  columnDef: ListGridColumn,
  dataView: LMListDataView,
  dataGrid: SohoDataGridStatic
): string  => {

  if (dataView.isTreeMoreLink && dataGrid) {
    const listGridComponent = dataGrid.settings.userObject();
    let moreColumnIndex = dataGrid.settings.selectable === 'single' ? 0 : 1;
    if (listGridComponent.hasFlyoutColumn)
      moreColumnIndex++;
    return lmFormatterService.getMoreLink(cell, dataView, moreColumnIndex);
  }

  const displayField = columnDef.displayField;

  if (displayField.visibility) {
    if (!lmFormatterService.isConditionValid(displayField.visibility, dataView)) {
      return '';
    }
  }

  if (displayField.inlineCreateFieldId) {
    if (dataView.fields && dataView.fields[ displayField.inlineCreateFieldId ]) {
      // LMCLIENT-34312: Value is escaped and the formatted value will be HTML encoded to be displayed in cell node HTML.
      // dataView.fields(displayField.fieldId) is already set using the unescaped coerced value in sohoxi.
      // (See SOHO Datagrid's commitCellEdit that calls updateCellNode routine)
      if (dataView.fields[ displayField.fieldId ]) {
        dataView.fields[ displayField.inlineCreateFieldId ].value = dataView.fields[ displayField.fieldId ].value;
      } else {
        dataView.fields[ displayField.inlineCreateFieldId ].value = value;
      }
    }
  }

  if (displayField.displayMsgRule && displayField.displayWhen) {
    if (lmFormatterService.isConditionValid([ displayField.displayWhen ], dataView)) {
      return lmFormatUtilService.formatMessageRule(displayField.displayMsgRule, dataView);
    }
  }

  const listGridComponent = dataGrid.settings.userObject();
  const displayValue = lmFormatterService.getDisplayText(displayField, value, dataView, listGridComponent.dataViewSet, row);
  let displayText =  lmFormatterService.formatDisplayText(row, cell, displayValue, columnDef, dataView, dataGrid);

  // if (displayField.forceLinkForOverlay && !dataView.redirectAction) {
  //   // force displaying first column as a link which opens the form is for the list spec in an overlay
  //   displayText = lmFormatterService.formatButtonText(row, cell, displayValue, columnDef, dataView, dataGrid);
  //
  if (displayField.isTreeColumn && displayField.linkNavigation) {
    // first column of tree is a navigation
    columnDef.displayField.displayAsLink = true;
    displayText = lmFormatterService.formatButtonText(row, cell, displayValue, columnDef, dataView, dataGrid);
    return Soho.Formatters.Tree(row, cell, displayText, columnDef, dataView, dataGrid);
  }
  // }

  if (lmFormatterService.expandableRowCardView() && columnDef.columnNumber === 0 && !lmFormatterService.isTotalRow(dataView)) {
    columnDef.cssClass = 'lm-expand-button';
    return Soho.Formatters.Expander(row, cell, displayText, columnDef, dataView, dataGrid);
  }

  // Check if there is a value.
  // If there is no value then the control still displays the "reveal (eye)" icon on hover
  if (displayField.maskInfo && displayValue && displayValue.length > 0) {

    // GenAI Generated code - Start
    // Field-level conditional mask: when the mask visibility condition is present and evaluates
    // false, do not mask — render the plain value.
    if (displayField.maskInfo.visibility
        && !lmFormatterService.isConditionValid([ displayField.maskInfo.visibility ], dataView)) {
      return displayText;
    }
    // GenAI Generated code - End

    if (displayField.maskInfo?.showLastNumberOfCharacters?.type === "field"
      && dataView?.fields[displayField?.maskInfo?.showLastNumberOfCharacters?.fieldId]?.value
    ) {

      columnDef.revealTextSettings.revealCharacters = Number(dataView.fields[displayField.maskInfo.showLastNumberOfCharacters.fieldId].value);
      return Soho.Formatters.RevealableText(row, cell, displayText, columnDef, dataView, dataGrid);
    }

    return Soho.Formatters.RevealableText(row, cell, displayText, columnDef, dataView, dataGrid);
  }

  return displayText;
};
